'use client';

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Import images
import logo from '../../assets/images/logo.svg';

import whatsappIcon from '../../assets/images/whatsapp_icon.svg';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsMenuOpen(false);
      setIsClosing(false);
    }, 300);
  };

  const handleLinkClick = () => {
    closeMenu();
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <header className="contact-bar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        <div className="second-menu">
          {/* <div className="contact-info d-flex gap-2">
            <Link
              to="/contact-us"
              className="d-flex align-items-center gap-2 text-decoration-none"
            >
              <i className="bi bi-telephone-fill"></i>
              {t('contact_us')}
            </Link>
            <a
              href="mailto:info@shahlpo.com"
              className="d-flex align-items-center gap-2 text-decoration-none"
            >
              <i className="bi bi-envelope-fill"></i>
              {t('email')}
            </a>
          </div> */}
          <div className="button_details mt-1">
            <div className="main_button">
              <a href="#" className="blue_btn">
                <div className="phone-number">
                  {' '}
                  <a
                    href="tel:+971585703027"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    <p style={{ marginBottom: 0 }}>+971-585703027</p>
                  </a>
                </div>
              </a>
            </div>
          </div>
          <div className="icons icon-wp">
            <div className="whatsapp_deta whatsapp-icon">
              <a
                href="https://wa.me/971585703027?text=Hi%2C%20I%20would%20like%20to%20book%20a%20consultation."
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={whatsappIcon}
                  alt="WhatsApp"
                  style={{ width: '32px', height: '32px' }}
                />
              </a>
            </div>
          </div>
          <div className="icons">
            <div className="icon-wrapper facebook-bg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision"
                image-rendering="optimizeQuality"
                fill-rule="evenodd"
                clip-rule="evenodd"
                viewBox="0 0 509 509"
              >
                <g fill-rule="nonzero">
                  <path
                    fill="#0866FF"
                    d="M509 254.5C509 113.94 395.06 0 254.5 0S0 113.94 0 254.5C0 373.86 82.17 474 193.02 501.51V332.27h-52.48V254.5h52.48v-33.51c0-86.63 39.2-126.78 124.24-126.78 16.13 0 43.95 3.17 55.33 6.33v70.5c-6.01-.63-16.44-.95-29.4-.95-41.73 0-57.86 15.81-57.86 56.91v27.5h83.13l-14.28 77.77h-68.85v174.87C411.35 491.92 509 384.62 509 254.5z"
                  />
                  <path
                    fill="#fff"
                    d="M354.18 332.27l14.28-77.77h-83.13V227c0-41.1 16.13-56.91 57.86-56.91 12.96 0 23.39.32 29.4.95v-70.5c-11.38-3.16-39.2-6.33-55.33-6.33-85.04 0-124.24 40.16-124.24 126.78v33.51h-52.48v77.77h52.48v169.24c19.69 4.88 40.28 7.49 61.48 7.49 10.44 0 20.72-.64 30.83-1.86V332.27h68.85z"
                  />
                </g>
              </svg>
            </div>
            <div className="icon-wrapper twitter-bg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision"
                image-rendering="optimizeQuality"
                fill-rule="evenodd"
                clip-rule="evenodd"
                viewBox="0 0 512 512"
              >
                <path d="M256 0c141.385 0 256 114.615 256 256S397.385 512 256 512 0 397.385 0 256 114.615 0 256 0z" />
                <path
                  fill="#fff"
                  fill-rule="nonzero"
                  d="M318.64 157.549h33.401l-72.973 83.407 85.85 113.495h-67.222l-52.647-68.836-60.242 68.836h-33.423l78.052-89.212-82.354-107.69h68.924l47.59 62.917 55.044-62.917zm-11.724 176.908h18.51L205.95 176.493h-19.86l120.826 157.964z"
                />
              </svg>
            </div>
            <div className="icon-wrapper linkedin-bg">
              <svg
                className="w-6 h-6 text-white dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.51 8.796v1.697a3.738 3.738 0 0 1 3.288-1.684c3.455 0 4.202 2.16 4.202 4.97V19.5h-3.2v-5.072c0-1.21-.244-2.766-2.128-2.766-1.827 0-2.139 1.317-2.139 2.676V19.5h-3.19V8.796h3.168ZM7.2 6.106a1.61 1.61 0 0 1-.988 1.483 1.595 1.595 0 0 1-1.743-.348A1.607 1.607 0 0 1 5.6 4.5a1.601 1.601 0 0 1 1.6 1.606Z"
                  clip-rule="evenodd"
                />
                <path d="M7.2 8.809H4V19.5h3.2V8.809Z" />
              </svg>
            </div>
            <div className="icon-wrapper thread-bg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision"
                image-rendering="optimizeQuality"
                fill-rule="evenodd"
                clip-rule="evenodd"
                viewBox="0 0 512 512"
                className="rounded-5"
              >
                <path d="M105 0h302c57.75 0 105 47.25 105 105v302c0 57.75-47.25 105-105 105H105C47.25 512 0 464.75 0 407V105C0 47.25 47.25 0 105 0z" />
                <path
                  fill="#fff"
                  fill-rule="nonzero"
                  d="M337.36 243.58c-1.46-.7-2.95-1.38-4.46-2.02-2.62-48.36-29.04-76.05-73.41-76.33-25.6-.17-48.52 10.27-62.8 31.94l24.4 16.74c10.15-15.4 26.08-18.68 37.81-18.68h.4c14.61.09 25.64 4.34 32.77 12.62 5.19 6.04 8.67 14.37 10.39 24.89-12.96-2.2-26.96-2.88-41.94-2.02-42.18 2.43-69.3 27.03-67.48 61.21.92 17.35 9.56 32.26 24.32 42.01 12.48 8.24 28.56 12.27 45.26 11.35 22.07-1.2 39.37-9.62 51.45-25.01 9.17-11.69 14.97-26.84 17.53-45.92 10.51 6.34 18.3 14.69 22.61 24.73 7.31 17.06 7.74 45.1-15.14 67.96-20.04 20.03-44.14 28.69-80.55 28.96-40.4-.3-70.95-13.26-90.81-38.51-18.6-23.64-28.21-57.79-28.57-101.5.36-43.71 9.97-77.86 28.57-101.5 19.86-25.25 50.41-38.21 90.81-38.51 40.68.3 71.76 13.32 92.39 38.69 10.11 12.44 17.73 28.09 22.76 46.33l28.59-7.63c-6.09-22.45-15.67-41.8-28.72-57.85-26.44-32.53-65.1-49.19-114.92-49.54h-.2c-49.72.35-87.96 17.08-113.64 49.73-22.86 29.05-34.65 69.48-35.04 120.16v.24c.39 50.68 12.18 91.11 35.04 120.16 25.68 32.65 63.92 49.39 113.64 49.73h.2c44.2-.31 75.36-11.88 101.03-37.53 33.58-33.55 32.57-75.6 21.5-101.42-7.94-18.51-23.08-33.55-43.79-43.48zm-76.32 71.76c-18.48 1.04-37.69-7.26-38.64-25.03-.7-13.18 9.38-27.89 39.78-29.64 3.48-.2 6.9-.3 10.25-.3 11.04 0 21.37 1.07 30.76 3.13-3.5 43.74-24.04 50.84-42.15 51.84z"
                />
              </svg>
            </div>
            <div className="icon-wrapper instagram-bg">
              <svg
                className="icon-svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="18" cy="6" r="1" />
              </svg>
            </div>
          </div>

          <div className="d-flex align-items-start gap-2 me-4 poin">
            <div className="language">
              <select
                className="form-select form-select-sm border border-white text-white fw-bold bg-transparent"
                style={{ boxShadow: 'none', cursor: 'pointer' }}
                onChange={(e) => changeLanguage(e.target.value)}
              >
                <option value="en" className="fw-bold text-dark">
                  En
                </option>
                <option value="ar" className="fw-bold text-dark">
                  Ar
                </option>
              </select>
            </div>
          </div>
        </div>

        <div className="menubars">
          <div className="d-flex align-items-center gap-2 d-lg-none">
            <div className="whatsapp_deta">
              <a
                href="https://wa.me/971585703027?text=Hi%2C%20I%20would%20like%20to%20book%20a%20consultation."
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={whatsappIcon}
                  alt="WhatsApp"
                  style={{ width: '32px', height: '32px', display: 'flex' }}
                />
              </a>
            </div>
            <div className="language">
              <select
                className="form-select form-select-sm border border-white text-white fw-bold bg-transparent"
                style={{ boxShadow: 'none', cursor: 'pointer' }}
                onChange={(e) => changeLanguage(e.target.value)}
              >
                <option value="en" className="fw-bold text-dark">
                  En
                </option>
                <option value="ar" className="fw-bold text-dark">
                  Ar
                </option>
              </select>
            </div>
          </div>
          <nav className="navbar navbar-light">
            <div className="container-fluid">
              <button
                className="btn btn-menus"
                type="button"
                onClick={toggleMenu}
              >
                <span>☰</span>
              </button>
            </div>
          </nav>
        </div>

        {isMenuOpen && (
          <div className="offcanvas-backdrop show" onClick={closeMenu}></div>
        )}

        <div
          className={`offcanvas offcanvas-start ${isMenuOpen ? 'show' : ''} ${isClosing ? 'hiding' : ''}`}
          tabIndex={-1}
          style={{ visibility: isMenuOpen ? 'visible' : 'hidden' }}
        >
          <div className="offcanvas-header">
            <div className="offcanva_logo">
              <img src={logo} alt="Logo" />
            </div>

            <button
              type="button"
              className="btn-close"
              onClick={closeMenu}
              aria-label="Close"
            ></button>
          </div>

          <div className="offcanvas-body">
            <ul className="nav flex-column">
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={handleLinkClick}>
                  {t('home')}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/about-us"
                  onClick={handleLinkClick}
                >
                  {t('about_us')}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/services"
                  onClick={handleLinkClick}
                >
                  {t('services')}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/blog" onClick={handleLinkClick}>
                  {t('blogs')}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/contact-us"
                  onClick={handleLinkClick}
                >
                  {t('contact_us')}
                </Link>
              </li>
            </ul>

            <div className="influencer">
              <div className="main-title mt-2">
                {/* <h5>{t('social_icon')}</h5> */}
                <div className="icons">
                  <div className="icon-wrapper facebook-bg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      shape-rendering="geometricPrecision"
                      text-rendering="geometricPrecision"
                      image-rendering="optimizeQuality"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      viewBox="0 0 509 509"
                    >
                      <g fill-rule="nonzero">
                        <path
                          fill="#0866FF"
                          d="M509 254.5C509 113.94 395.06 0 254.5 0S0 113.94 0 254.5C0 373.86 82.17 474 193.02 501.51V332.27h-52.48V254.5h52.48v-33.51c0-86.63 39.2-126.78 124.24-126.78 16.13 0 43.95 3.17 55.33 6.33v70.5c-6.01-.63-16.44-.95-29.4-.95-41.73 0-57.86 15.81-57.86 56.91v27.5h83.13l-14.28 77.77h-68.85v174.87C411.35 491.92 509 384.62 509 254.5z"
                        />
                        <path
                          fill="#fff"
                          d="M354.18 332.27l14.28-77.77h-83.13V227c0-41.1 16.13-56.91 57.86-56.91 12.96 0 23.39.32 29.4.95v-70.5c-11.38-3.16-39.2-6.33-55.33-6.33-85.04 0-124.24 40.16-124.24 126.78v33.51h-52.48v77.77h52.48v169.24c19.69 4.88 40.28 7.49 61.48 7.49 10.44 0 20.72-.64 30.83-1.86V332.27h68.85z"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="icon-wrapper twitter-bg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      shape-rendering="geometricPrecision"
                      text-rendering="geometricPrecision"
                      image-rendering="optimizeQuality"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      viewBox="0 0 512 512"
                    >
                      <path d="M256 0c141.385 0 256 114.615 256 256S397.385 512 256 512 0 397.385 0 256 114.615 0 256 0z" />
                      <path
                        fill="#fff"
                        fill-rule="nonzero"
                        d="M318.64 157.549h33.401l-72.973 83.407 85.85 113.495h-67.222l-52.647-68.836-60.242 68.836h-33.423l78.052-89.212-82.354-107.69h68.924l47.59 62.917 55.044-62.917zm-11.724 176.908h18.51L205.95 176.493h-19.86l120.826 157.964z"
                      />
                    </svg>
                  </div>
                  <div className="icon-wrapper linkedin-bg">
                    <svg
                      className="w-6 h-6 text-white dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12.51 8.796v1.697a3.738 3.738 0 0 1 3.288-1.684c3.455 0 4.202 2.16 4.202 4.97V19.5h-3.2v-5.072c0-1.21-.244-2.766-2.128-2.766-1.827 0-2.139 1.317-2.139 2.676V19.5h-3.19V8.796h3.168ZM7.2 6.106a1.61 1.61 0 0 1-.988 1.483 1.595 1.595 0 0 1-1.743-.348A1.607 1.607 0 0 1 5.6 4.5a1.601 1.601 0 0 1 1.6 1.606Z"
                        clip-rule="evenodd"
                      />
                      <path d="M7.2 8.809H4V19.5h3.2V8.809Z" />
                    </svg>
                  </div>
                  <div className="icon-wrapper thread-bg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      shape-rendering="geometricPrecision"
                      text-rendering="geometricPrecision"
                      image-rendering="optimizeQuality"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      viewBox="0 0 512 512"
                      className="rounded-5"
                    >
                      <path d="M105 0h302c57.75 0 105 47.25 105 105v302c0 57.75-47.25 105-105 105H105C47.25 512 0 464.75 0 407V105C0 47.25 47.25 0 105 0z" />
                      <path
                        fill="#fff"
                        fill-rule="nonzero"
                        d="M337.36 243.58c-1.46-.7-2.95-1.38-4.46-2.02-2.62-48.36-29.04-76.05-73.41-76.33-25.6-.17-48.52 10.27-62.8 31.94l24.4 16.74c10.15-15.4 26.08-18.68 37.81-18.68h.4c14.61.09 25.64 4.34 32.77 12.62 5.19 6.04 8.67 14.37 10.39 24.89-12.96-2.2-26.96-2.88-41.94-2.02-42.18 2.43-69.3 27.03-67.48 61.21.92 17.35 9.56 32.26 24.32 42.01 12.48 8.24 28.56 12.27 45.26 11.35 22.07-1.2 39.37-9.62 51.45-25.01 9.17-11.69 14.97-26.84 17.53-45.92 10.51 6.34 18.3 14.69 22.61 24.73 7.31 17.06 7.74 45.1-15.14 67.96-20.04 20.03-44.14 28.69-80.55 28.96-40.4-.3-70.95-13.26-90.81-38.51-18.6-23.64-28.21-57.79-28.57-101.5.36-43.71 9.97-77.86 28.57-101.5 19.86-25.25 50.41-38.21 90.81-38.51 40.68.3 71.76 13.32 92.39 38.69 10.11 12.44 17.73 28.09 22.76 46.33l28.59-7.63c-6.09-22.45-15.67-41.8-28.72-57.85-26.44-32.53-65.1-49.19-114.92-49.54h-.2c-49.72.35-87.96 17.08-113.64 49.73-22.86 29.05-34.65 69.48-35.04 120.16v.24c.39 50.68 12.18 91.11 35.04 120.16 25.68 32.65 63.92 49.39 113.64 49.73h.2c44.2-.31 75.36-11.88 101.03-37.53 33.58-33.55 32.57-75.6 21.5-101.42-7.94-18.51-23.08-33.55-43.79-43.48zm-76.32 71.76c-18.48 1.04-37.69-7.26-38.64-25.03-.7-13.18 9.38-27.89 39.78-29.64 3.48-.2 6.9-.3 10.25-.3 11.04 0 21.37 1.07 30.76 3.13-3.5 43.74-24.04 50.84-42.15 51.84z"
                      />
                    </svg>
                  </div>
                  <div className="icon-wrapper instagram-bg">
                    <svg
                      className="icon-svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="1.5"
                    >
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                      <circle cx="12" cy="12" r="4" />
                      <circle cx="18" cy="6" r="1" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="button_details mt-3">
              <div className="main_button">
                <a href="tel:+971585816688" className="blue_btn">
                  <div className="phone-number">+971-585703027</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
      <style>
        {`.whatsapp-icon {
  transition: transform 0.3s ease, filter 0.3s ease;
}

.whatsapp-icon:hover {
  transform: scale(1.1);
  
}`}
      </style>
    </>
  );
};

export default Header;
